import moment from 'moment';

export const DATA_EXPORTS_EARLIEST_DATE = moment.utc('2006-01-01');



// WEBPACK FOOTER //
// ./modules/DataExports/constants.js